export enum TokenValidationErrorTypes {
  noError = 0,
  invalidToken = 10,
  tokenIsUsed = 20,
  tokenIsExpired = 30,
  unexpectedError = 100
}
